<!--
  ~ Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
  ~ This software is the proprietary information of Irian Software Development SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class="container">
  <div class="row align-items-center">
    <form #loginForm class="col-12 col-sm-6  mt-lg">
      <div class="">
        <div class="login-wrapper justify-content-xs-center  col-sm-12 ">
          <div>
            <h2>{{'auth.login-details' | translate}}: </h2>
            <p-messages [(value)]="statusMessages"></p-messages>
          </div>
          <div>
            <label class="col-12 my-sm" for="username">{{'auth.username' | translate}}</label>
            <input class="col-12" id="username" type="text" size="30" pInputText
                   [(ngModel)]="loginDetails.username" name="username" autofocus data-testid="username-input">
          </div>
          <div class='mt-2'>
            <label class="col-12 my-sm" for="password">{{'auth.password' | translate}}</label>
            <p-password id="password" size="30"
                        class="col-12"
                        styleClass="col-12"
                        inputStyleClass="col-12"
                        [(ngModel)]="loginDetails.password" name="password"
                        [toggleMask]="true" data-testid="password-password-input"></p-password>
          </div>
          <div class="row mt">
            <button pButton type="submit" [label]="'auth.login' | translate" class="mt-md" (click)="login()" data-testid="login-btn"></button>
            <button pButton type="submit" *ngIf="userUnactivated" [label]="'auth.resend-email-confirmation.button' | translate"
                    class="mt-md resend-email-confirmation" (click)="resendEmailConfirmation()" data-testid="button-btn"></button>
          </div>
          <div class="user-management-links">
            <div class="row">
              <button pButton [label]="'auth.password-recovery-request-link' | translate" type="button"
                      (click)="goToPasswordRecoveryRequest()" class="link-button" data-testid="password-recovery-request-btn"></button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>


